import {
	getOverlayFromMission,
	getScreenFromMission,
	getIsScreenLoopingFromMission,
	type Screen,
	type BothFullMissionStates,
	type Overlay,
} from '@mission.io/mission-toolkit'

type State = ?BothFullMissionStates

/**
 * Gets whether or not to show the current timer for the screen.
 */
export function shouldShowScreenTimer(state: State): boolean {
	return Boolean(state?.launchpad.screen?.showTimer)
}

const SCREEN_HANDLES_TIMER = new Set(['CULMINATING_MOMENT'])

/**
 * Gets whether or not to show the current timer for the screen.
 */
export function shouldShowNotificationScreenTimer(state: State): boolean {
	const timerType = state?.launchpad.screen?.type || ''
	return Boolean(
		shouldShowScreenTimer(state) && !SCREEN_HANDLES_TIMER.has(timerType)
	)
}

/**
 * Gets current timer for the current screen.
 */
export function getScreenTimer(state: State): ?string {
	return state?.launchpad.screen?.timerId
}

/**
 * Gets current timer for the notification timer if applicable.
 */
export function getScreenTimerForNotifications(state: State): ?string {
	if (shouldShowNotificationScreenTimer(state)) {
		return getScreenTimer(state)
	}
	return null
}

/**
 * Gets current timer for the screen if applicable
 */
export function getScreenTimerForCustomScreenHandling(state: State): ?string {
	if (SCREEN_HANDLES_TIMER.has(state?.launchpad.screen?.type || '')) {
		return getScreenTimer(state)
	}
	return null
}

export function getScreen(state: State): ?Screen {
	return getScreenFromMission(state)
}

export function getIsScreenLooping(state: State): boolean {
	return getIsScreenLoopingFromMission(state)
}

export function getOverlay(state: State): ?Overlay {
	return getOverlayFromMission(state)
}
